// serverClock keeps the difference between this device's clock and ours.
//
// The hold deadline (OH-82) is an absolute instant chosen by the server, and
// the countdown next to it is only as true as the clock it is measured
// against. A device running ten minutes slow would show a guest fifteen
// minutes of reservation while the server intends to release the dates in
// five — the kind of promise that turns into "but it said I had time".
//
// Correction comes from the `Date` header every API response already carries:
// no extra request, no endpoint to add.

// MIN_SKEW_MS — corrections below this are treated as latency, not drift.
// Some of the gap between the server stamping the header and us reading it is
// just the network; chasing that would make the clock jitter on each refetch
// while telling the guest nothing new.
const MIN_SKEW_MS = 5_000;

let skewMs = 0;

// noteServerDate records the server's own idea of "now" from a response
// header. Unparseable or absent values are ignored — a missing header must
// leave the clock alone, never freeze or reset it.
export function noteServerDate(header: string | null | undefined): void {
  if (!header) return;
  const serverMs = Date.parse(header);
  if (Number.isNaN(serverMs)) return;
  const delta = serverMs - Date.now();
  if (Math.abs(delta) < MIN_SKEW_MS) return;
  skewMs = delta;
}

// serverNow returns the current time as the server would state it. Falls back
// to the device clock, which is right for the overwhelming majority of
// devices and wrong only in the way this module exists to correct.
export function serverNow(): number {
  return Date.now() + skewMs;
}

// __resetServerClock exists for tests: module state would otherwise leak a
// skew learned in one test into the next.
export function __resetServerClock(): void {
  skewMs = 0;
}
